import ConcertBand from "../images/78ConcertBand.webp";
import MarchingCeremonialBand from "../images/armyband1.webp";
import BrassQuintet from "../images/armyband7.webp";
import Checkmate from "../images/Checkmate.webp";
import FortDixielandBrassBand from "../images/FortDixielandBrassBand.webp";
import NineByNine from "../images/9x9.jpg";
import LibertyVibes from "../images/LibertyVibes.webp";

export const ensembles = [
  {
    id: 1,
    name: "Concert Band",
    bio: "The concert band is one that performs the large repertoire for wind ensemble and military wind bands. This non-marching group provides music and support for military events, community outreach, and mentorship events as well as presenting a fostering foreign relations in special occasions. With all ensembles, the concert band bridges the gap between the military and civilian communities.",
    img: ConcertBand,
  },
  {
    id: 2,
    name: "Marching/Ceremonial Band",
    bio: "The marching band is organized into a prescribed formation and is usually led by a drum major and a conductor. Consisting of all of the members of the unit, it is the only ceremonial ensemble that plays while marching.",
    img: MarchingCeremonialBand,
  },

  {
    id: 3,
    name: "Brass Quintet",
    bio: "The Brass Quintet is a small brass ensemble that can play a variety of music, including classical, jazz, military marches, and popular tunes. They are a flexible group that can be featured as the main event as well as provide a musical background for military and state functions, dinner parties, and other types of festivals.",
    img: BrassQuintet,
  },

  {
    id: 4,
    name: "Checkmate",
    bio: "Checkmate is the 78th Army Band premier rock/pop ensemble that provides high-energy music to soldiers and civilians. Its musical catalog covers an eclectic array of tunes from the 1960s to the present. The highly talented musicians of the group enables the ensemble to cover many musical idioms from Rock, Funk, Country, and Pop. ¶ Musical performance highlights include: featured float for the Philadelphia 4th of July Parade, Intrepid Museum Memorial Day Concert, Morale and Welfare performance for over 3000 basic training soldiers at Ft. Jackson, SC, and the opening act for legendary rock group 38 Special and country music artist Gretchen Wilson for the Joint Base McGuire-Dix-Lakehurst’s 10-year anniversary celebration.",
    img: Checkmate,
  },
  {
    id: 5,
    name: "Fort Dix Brass Band",
    bio: "The Fort Dix Brass Band is one of the Music Performance Teams of the 78th Army Band, US Army Reserve, located at Joint Base McGuire-Dix-Lakehurst NJ and Fort Totten, Queens, NY. ¶ Formed in 2013, the ensemble performs an eclectic mix of popular music in the energetic style of a New Orleans Brass Band. Since its inception, the team has performed regularly at the Rehoboth Beach Bandstand Summer Concert Series, the Power in the Pines Air Show, the Milton (DE) Theater and for various civilian and military communities in the Northeast.",
    img: FortDixielandBrassBand,
  },
  {
    id: 6,
    name: "9x9",
    bio: "Formed by some of the newest members of the 78th Army Band, 9 x 9 is a tribute to the greatest pop punk acts of the 90's and early 2000's. Drawing on the experience of its members, 9 x 9 seeks to authentically capture the excitement and raw energy of a genre that dominated popular music  for nearly 20 years. Delivering fast-paced, dynamic performances, the band has won the hearts of audiences of all ages. If you enjoy the music of Fall Out Boy, Blink 182, and Paramore - be sure to check them out! ",
    img: NineByNine,
  },
  {
    id: 7,
    name: "Liberty Vibes",
    bio: "Liberty Vibes is a music performance team primarily made up of soldiers from the 78th Army Band at Ft. Totten, in New York City. This group performs arrangements of popular music as well as original compositions in a diverse range of Latin & Afro-Cuban styles. Although the ensemble features a complete section of brass, woodwinds, percussion, and vocals, the Liberty Vibes namesake was derived from the vibraphone that makes up the core of the rhythm section. Liberty Vibes is defined by an intriguing instrumentation and a unique fusion of styles, representing the diverse blend of cultures found in the City of New York, the U.S. Army, and the United States of America.",
    img: LibertyVibes,
  },
];
